<template>
  <div>
    <b-container class="self-assesment">
      <b-row>
        <b-col xl="10" offset-xl="1">
          <b-form @submit.prevent="">
            <!-- Rotación -->
            <fieldset class="compact">
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/humanResources_absences_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{ $t("label_selfAssessment_humanResources_numberTable") }}
                </h4>
                <h2>
                  {{ $t("label_selfAssessment_humanResources_absences_title") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_humanResources_absences_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <b-row class="table-9 table-header">
                  <b-col cols="3">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_absences_column_typeOfDay"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_absences_column_typeOfDay_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_absences_column_annualDaysAgreed"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_absences_column_annualDaysAgreed_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="6">
                    <b-row>
                      <b-col cols="6">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_humanResources_absences_column_numberOfStaff"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_humanResources_absences_column_numberOfStaff_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col cols="6">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_humanResources_absences_column_totalWorkDays"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_humanResources_absences_column_totalWorkDays_toolTip"
                          />
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="table-header">
                  <b-col cols="3" />
                  <b-col cols="3" />
                  <b-col cols="6">
                    <b-row>
                      <b-col cols="3">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_humanResources_absences_colum_numberOfStaff_women"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_humanResources_absences_colum_numberOfStaff_women_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col cols="3">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_humanResources_absences_colum_numberOfStaff_men"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_humanResources_absences_colum_numberOfStaff_men_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col cols="3">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_humanResources_absences_column_totalWorkDays_women"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_humanResources_absences_column_totalWorkDays_women_toolTip"
                          />
                        </p>
                      </b-col>
                      <b-col cols="3">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_humanResources_absences_column_totalWorkDays_men"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_humanResources_absences_column_totalWorkDays_men_toolTip"
                          />
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="3">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_absences_typeOfDay_WorkDays"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_absences_typeOfDay_WorkDays_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3">
                    <form-input-numeric
                      id="selfAssessment_humanResources_absences_annualDaysAgreed"
                      v-model="
                        selfAssessment_humanResources_absences_annualDaysAgreed
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateAbsences"
                    />
                  </b-col>
                  <b-col col>
                    <form-input-numeric
                      id="selfAssessment_humanResources_totalStaff_women"
                      v-model="staffResponsibilityTotalWomen"
                      required
                      min="0"
                      disabled
                    />
                  </b-col>
                  <b-col col>
                    <form-input-numeric
                      id="selfAssessment_humanResources_totalStaff_men"
                      v-model="staffResponsibilityTotalMen"
                      required
                      min="0"
                      disabled
                    />
                  </b-col>
                  <b-col col>
                    <form-input-numeric
                      id="selfAssessment_humanResources_absences_totalWorkDays_women"
                      v-model="absencesTotalWorkDaysWomen"
                      required
                      min="0"
                      disabled
                    />
                  </b-col>
                  <b-col col>
                    <form-input-numeric
                      id="selfAssessment_humanResources_absences_totalWorkDays_men"
                      v-model="absencesTotalWorkDaysMen"
                      required
                      min="0"
                      disabled
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="3">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_absences_typeOfDay_LostDays"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_absences_typeOfDay_LostDays_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3">
                    <form-input-numeric required placeholder="-" disabled />
                  </b-col>
                  <b-col col>
                    <form-input-numeric required placeholder="-" disabled />
                  </b-col>
                  <b-col col>
                    <form-input-numeric required placeholder="-" disabled />
                  </b-col>
                  <b-col col>
                    <form-input-numeric
                      id="selfAssessment_humanResources_absences_totalLostDays_women"
                      v-model="
                        selfAssessment_humanResources_absences_totalLostDays_women
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                  <b-col col>
                    <form-input-numeric
                      id="selfAssessment_humanResources_absences_totalLostDays_men"
                      v-model="
                        selfAssessment_humanResources_absences_totalLostDays_men
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
              </div>
            </fieldset>
            <!-- End - Rotación -->
            <!-- Rotación por cese de Actividades -->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/humanResources_absenceDueStoppage_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{
                    $t(
                      "label_selfAssessment_humanResources_absenceDueStoppage_numberTable"
                    )
                  }}
                </h4>
                <h2>
                  {{
                    $t(
                      "label_selfAssessment_humanResources_absenceDueStoppage_title"
                    )
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_humanResources_absenceDueStoppage_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <b-row class="table-header">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_absenceDueStoppage_columnNumberOfStaff"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_absenceDueStoppage_columnNumberOfStaff_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_absenceDueStoppage_colum_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_absenceDueStoppage_colum_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_absenceDueStoppage_colum_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_absenceDueStoppage_colum_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="6" sm="8">
                    <p>
                      {{ $t("label_selfAssessment_humanResources_totalStaff") }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_totalStaff_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_totalStaff_women"
                      v-model="staffResponsibilityTotalWomen"
                      required
                      min="0"
                      disabled
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_totalStaff_men"
                      v-model="staffResponsibilityTotalMen"
                      required
                      min="0"
                      disabled
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_absenceDueStoppage"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_absenceDueStoppage_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_absenceDueStoppage_women"
                      v-model="
                        selfAssessment_humanResources_absenceDueStoppage_women
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_absenceDueStoppage_men"
                      v-model="
                        selfAssessment_humanResources_absenceDueStoppage_men
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
              </div>
            </fieldset>
            <!-- End - Rotación por cese de Actividades -->
            <!-- REINCORPORACIÓN TRAS LICENCIA DE MATERNIDAD -->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/humanResources_returningAfterMaternityLeave_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{
                    $t(
                      "label_selfAssessment_humanResources_returningAfterMaternityLeave_numberTable"
                    )
                  }}
                </h4>
                <h2>
                  {{
                    $t(
                      "label_selfAssessment_humanResources_returningAfterMaternityLeave_title"
                    )
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_humanResources_returningAfterMaternityLeave_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <b-row class="table-header">
                  <b-col cols="9" sm="10" />
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_returningAfterMaternityLeave_colum_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_returningAfterMaternityLeave_colum_women_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="9" sm="10">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_returningAfterMaternityLeave_took"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_returningAfterMaternityLeave_took_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_returningAfterMaternityLeave_took"
                      v-model="
                        selfAssessment_humanResources_returningAfterMaternityLeave_took
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="9" sm="10">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_returningAfterMaternityLeave_didNotReturn"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_returningAfterMaternityLeave_didNotReturn_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_returningAfterMaternityLeave_didNotReturn"
                      v-model="
                        selfAssessment_humanResources_returningAfterMaternityLeave_didNotReturn
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="9" sm="10">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_returningAfterMaternityLeave_return"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_returningAfterMaternityLeave_return_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_returningAfterMaternityLeave_return"
                      v-model="
                        selfAssessment_humanResources_returningAfterMaternityLeave_return
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
              </div>
            </fieldset>
            <!-- End - REINCORPORACIÓN TRAS LICENCIA DE MATERNIDAD -->
            <!-- INCORPORACIÓN Y NUEVAS CONTRATACIONES -->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/humanResources_staffing_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{
                    $t(
                      "label_selfAssessment_humanResources_staffing_numberTable"
                    )
                  }}
                </h4>
                <h2>
                  {{ $t("label_selfAssessment_humanResources_staffing_title") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_humanResources_staffing_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <b-row class="table-header">
                  <b-col cols="6" sm="8" />
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_staffing_colum_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_staffing_colum_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_staffing_title_colum_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_staffing_title_colum_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_staffing_applicants"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_staffing_applicants_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_staffing_applicants_women"
                      v-model="
                        selfAssessment_humanResources_staffing_applicants_women
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_staffing_applicants_men"
                      v-model="
                        selfAssessment_humanResources_staffing_applicants_men
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_staffing_newHires"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_staffing_newHires_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_staffing_newHires_women"
                      v-model="
                        selfAssessment_humanResources_staffing_newHires_women
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_staffing_newHires_men"
                      v-model="
                        selfAssessment_humanResources_staffing_newHires_men
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
              </div>
            </fieldset>
            <!-- End - INCORPORACIÓN Y NUEVAS CONTRATACIONES -->
            <!-- PROMOCIONES INTERNAS -->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/humanResources_internalPromotions_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{
                    $t(
                      "label_selfAssessment_humanResources_internalPromotions_numberTable"
                    )
                  }}
                </h4>
                <h2>
                  {{
                    $t(
                      "label_selfAssessment_humanResources_internalPromotions_title"
                    )
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_humanResources_internalPromotions_title_toolTip"
                  />
                </h2>
              </div>

              <div class="table">
                <b-row class="table-header">
                  <b-col cols="6" sm="8" />
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_internalPromotions_colum_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_internalPromotions_colum_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_internalPromotions_colum_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_internalPromotions_colum_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_internalPromotions_nominated"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_internalPromotions_nominated_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_internalPromotions_nominated_women"
                      v-model="
                        selfAssessment_humanResources_internalPromotions_nominated_women
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_internalPromotions_nominated_men"
                      v-model="
                        selfAssessment_humanResources_internalPromotions_nominated_men
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_internalPromotions_promoted"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_internalPromotions_promoted_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_internalPromotions_promoted_women"
                      v-model="
                        selfAssessment_humanResources_internalPromotions_promoted_women
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_internalPromotions_promoted_men"
                      v-model="
                        selfAssessment_humanResources_internalPromotions_promoted_men
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
              </div>
            </fieldset>
            <!-- End - PROMOCIONES INTERNAS -->
            <!-- FORMACIÓN O CAPACITACIÓN -->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/humanResources_education_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{
                    $t(
                      "label_selfAssessment_humanResources_education_numberTable"
                    )
                  }}
                </h4>
                <h2>
                  {{
                    $t("label_selfAssessment_humanResources_education_title")
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_humanResources_education_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <b-row class="table-header">
                  <b-col cols="6" sm="8" />
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_education_colum_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_education_colum_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_education_colum_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_education_colum_men_toolTip"
                      />
                    </p>
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_totalNumberStaff"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_totalNumberStaff_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_totalNumberStaff_women"
                      v-model="staffResponsibilityTotalWomen"
                      required
                      min="0"
                      disabled
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_totalNumberStaff_men"
                      v-model="staffResponsibilityTotalMen"
                      required
                      min="0"
                      disabled
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_education_receivingTraining"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_education_receivingTraining_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_education_receivingTraining_women"
                      v-model="
                        selfAssessment_humanResources_education_receivingTraining_women
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_education_receivingTraining_men"
                      v-model="
                        selfAssessment_humanResources_education_receivingTraining_men
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
                <b-row class="form-group align-items-baseline">
                  <b-col cols="6" sm="8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_humanResources_education_trainingHours"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_humanResources_education_trainingHours_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_education_trainingHours_women"
                      v-model="
                        selfAssessment_humanResources_education_trainingHours_women
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                  <b-col cols="3" sm="2">
                    <form-input-numeric
                      id="selfAssessment_humanResources_education_trainingHours_men"
                      v-model="
                        selfAssessment_humanResources_education_trainingHours_men
                      "
                      required
                      min="0"
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessment"
                    />
                  </b-col>
                </b-row>
              </div>
            </fieldset>
            <!-- End - FORMACIÓN O CAPACITACIÓN -->
          </b-form>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="3">
          <b-button
            variant="primary"
            style="margin: 20px 0"
            to="/self-assessment/employment-policies"
            block
          >
            {{ $t("label_selfAssessment_button_continue") }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { createHelpers } from "vuex-map-fields";
import { mapGetters } from "vuex";

const { mapFields } = createHelpers({
  getterType: "getSelfAssessmentField",
  mutationType: "updateSelfAssessmentField",
});

export default {
  name: "SelfAssessmentLaborConditions",
  data: function () {
    return {
      breadcrumb: [
        {
          title: "Self Assessment",
          link: "/self-assessment",
        },
        {
          title: "Gestión del Personal",
          link: "/",
        },
      ],
    };
  },
  created: async function () {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    this.$store
      .dispatch("SELF_ASSESSMENT_GET")
      .then(() => {
        this.$store.commit("setReloadSelfAssessment", false);
      })
      .catch((err) => {
        console.log(err);
        this.$router.push("/home"); // TODO Handle the error in a better way
      });
  },
  methods: {
    updateSelfAssessment: function (event) {
      var data = {};
      data[event.target.id] =
        this.selfAssessment[event.target.id] === ""
          ? null
          : this.selfAssessment[event.target.id];
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateAbsences: function (event) {
      var data = {};
      data[event.target.id] =
        this.selfAssessment[event.target.id] === ""
          ? null
          : this.selfAssessment[event.target.id];
      data["selfAssessment_humanResources_absences_totalWorkDays_men"] =
        this.absencesTotalWorkDaysMen;
      data["selfAssessment_humanResources_absences_totalWorkDays_women"] =
        this.absencesTotalWorkDaysWomen;
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
  },
  computed: {
    absencesTotalWorkDaysMen: function () {
      return (
        this.selfAssessment_humanResources_absences_annualDaysAgreed *
        this.staffResponsibilityTotalMen
      );
    },
    absencesTotalWorkDaysWomen: function () {
      return (
        this.selfAssessment_humanResources_absences_annualDaysAgreed *
        this.staffResponsibilityTotalWomen
      );
    },
    staffResponsibilityTotalWomen: function () {
      const managementSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_executiveDirector_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_director_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel4_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel3_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel2_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel1_women"
          ]
        ) || 0);
      const otherPositionsSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_technical_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_administrative_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_support_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_operational_women"
          ]
        ) || 0);
      return managementSubtotalWomen + otherPositionsSubtotalWomen;
    },
    staffResponsibilityTotalMen: function () {
      const managementSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_executiveDirector_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_director_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel4_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel3_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel2_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel1_men"
          ]
        ) || 0);
      const otherPositionsSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_technical_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_administrative_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_suport_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_operational_men"
          ]
        ) || 0);
      return managementSubtotalMen + otherPositionsSubtotalMen;
    },
    ...mapGetters({
      selfAssessment: "getSelfAssessment",
      status: "getSelfAssessmentStatus",
      canUpdateSelfAssessment: "canUpdateSelfAssessment",
      getReloadSelfAssessment: "getReloadSelfAssessment",
    }),
    ...mapFields([
      "selfAssessment_humanResources_absenceDueStoppage_men",
      "selfAssessment_humanResources_absenceDueStoppage_women",
      "selfAssessment_humanResources_absences_annualDaysAgreed",
      "selfAssessment_humanResources_absences_totalLostDays_men",
      "selfAssessment_humanResources_absences_totalLostDays_women",
      "selfAssessment_humanResources_absences_totalWorkDays_men",
      "selfAssessment_humanResources_absences_totalWorkDays_women",
      "selfAssessment_humanResources_education_receivingTraining_men",
      "selfAssessment_humanResources_education_receivingTraining_women",
      "selfAssessment_humanResources_education_trainingHours_men",
      "selfAssessment_humanResources_education_trainingHours_women",
      "selfAssessment_humanResources_internalPromotions_nominated_men",
      "selfAssessment_humanResources_internalPromotions_nominated_women",
      "selfAssessment_humanResources_internalPromotions_promoted_men",
      "selfAssessment_humanResources_internalPromotions_promoted_women",
      "selfAssessment_humanResources_returningAfterMaternityLeave_didNotReturn",
      "selfAssessment_humanResources_returningAfterMaternityLeave_return",
      "selfAssessment_humanResources_returningAfterMaternityLeave_took",
      "selfAssessment_humanResources_staffing_applicants_men",
      "selfAssessment_humanResources_staffing_applicants_women",
      "selfAssessment_humanResources_staffing_newHires_men",
      "selfAssessment_humanResources_staffing_newHires_women",
      "selfAssessment_humanResources_totalNumberStaff_men",
      "selfAssessment_humanRiconesources_totalNumberStaff_women",
      "selfAssessment_humanResources_totalPeopleStaff_men",
      "selfAssessment_humanResources_totalPeopleStaff_women",
      "selfAssessment_humanResources_totalStaff_men",
      "selfAssessment_humanResources_totalStaff_women",
    ]),
  },
};
</script>

<style lang="sass" scoped>

.table-9.table-header p
  min-height: 54px
</style>
